import {styled} from 'common'
import {Input as RawInput, FormControl} from '@mui/material'
import {paramCase} from 'change-case'

const Input = ({label, dataTestId, registered, ...p}) => {
    return (
        <FormControl {...p}>
            <RawInput
                placeholder={label}
                data-test-id={`input-${paramCase(
                    label || dataTestId || 'undefined'
                )}`}
                {...p}
            />
        </FormControl>
    )
}
export default styled(Input)``
